
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ActivityInterface": [
      "AutoArchivedActivity",
      "AutoCancelledActivity",
      "GenerateAdvancePaymentActivity",
      "GenericActivity",
      "OutgoingItemsRemovedActivity"
    ],
    "ActivityWithItemsInterface": [
      "AutoArchivedActivity",
      "AutoCancelledActivity",
      "OutgoingItemsRemovedActivity"
    ],
    "AssetInterface": [
      "Asset",
      "Image",
      "Video"
    ],
    "CategoryInterface": [
      "Artist",
      "Brand",
      "Category",
      "Label",
      "Tour"
    ],
    "ItemGroupInterface": [
      "IncomingItemGroup",
      "OutgoingItemGroup"
    ],
    "ProductInterface": [
      "DiscountProduct",
      "Event",
      "MerchProduct",
      "ShippingProduct"
    ],
    "ProductVariantInterface": [
      "EventProductVariant",
      "ProductVariant"
    ]
  }
};
      export default result;
    